export default "__VITE_ASSET__Dv44YAZ8__"